import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Loader2, Library } from "lucide-react";

export const SeriesModal = ({ open, onOpenChange, onSubmit, subscribed }) => {
  const [name, setName] = useState("");
  const [premise, setPremise] = useState("");
  const [characters, setCharacters] = useState("");
  const [setting, setSetting] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!name.trim() || busy) return;
    setBusy(true);
    try {
      await onSubmit({ name: name.trim(), premise, characters, setting });
      setName(""); setPremise(""); setCharacters(""); setSetting("");
    } finally {
      setBusy(false);
    }
  };

  const field = "w-full bg-navy-950/60 border border-gold-500/12 focus-visible:ring-gold-400/60 rounded-lg font-read text-slate-100 placeholder:text-slate-500";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="series-modal" className="max-w-lg bg-navy-950 border-gold-500/12 text-slate-100 max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-slate-100 flex items-center gap-2">
            <Library className="w-5 h-5 text-slate-300" /> New series
          </DialogTitle>
          <DialogDescription className="text-slate-400 font-read">
            Define the shared cast and world once. KLYR keeps them consistent across every book in the series —
            plus series-level metadata and continuity. Series Mode unlocks for $19 per series.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 mt-2">
          <div>
            <label className="font-ui text-[11px] uppercase tracking-wider text-slate-400">Series name</label>
            <input data-testid="series-name-input" value={name} onChange={(e) => setName(e.target.value)}
              placeholder="e.g. The Dragon of Aeria" className={field + " px-3 py-2.5 mt-1.5 outline-none"} />
          </div>
          <div>
            <label className="font-ui text-[11px] uppercase tracking-wider text-slate-400">Premise (optional)</label>
            <Textarea data-testid="series-premise-input" value={premise} onChange={(e) => setPremise(e.target.value)}
              placeholder="The overarching story or theme that connects the books." className={field + " min-h-[70px] resize-none mt-1.5 border-gold-500/12"} />
          </div>
          <div>
            <label className="font-ui text-[11px] uppercase tracking-wider text-slate-400">Recurring characters</label>
            <Textarea data-testid="series-characters-input" value={characters} onChange={(e) => setCharacters(e.target.value)}
              placeholder="Names, personalities and appearances to keep identical in every book." className={field + " min-h-[80px] resize-none mt-1.5 border-gold-500/12"} />
          </div>
          <div>
            <label className="font-ui text-[11px] uppercase tracking-wider text-slate-400">World &amp; settings</label>
            <Textarea data-testid="series-setting-input" value={setting} onChange={(e) => setSetting(e.target.value)}
              placeholder="Locations, rules and tone of the world your series lives in." className={field + " min-h-[80px] resize-none mt-1.5 border-gold-500/12"} />
          </div>
        </div>

        <button data-testid="series-create-button" onClick={submit} disabled={!name.trim() || busy}
          className="mt-5 w-full flex items-center justify-center gap-2 klyr-btn-metal disabled:opacity-50 font-ui text-sm font-semibold rounded-xl px-4 py-3 transition-[filter]">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />}
          Create &amp; unlock — $19
        </button>
      </DialogContent>
    </Dialog>
  );
};
